import React from 'react';
import './scrollToElementBtn_component.scss';

const ScrollToElementBtn = (props) => {

  const handleScroll = ref => {
    let elTop = document.getElementById(ref).getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      behavior: "smooth",
      top: elTop - document.getElementById('luiss-navbar').offsetHeight,
    });
  };


  return (
    <div className="top-to-btm">
      {
        <button onClick={() => handleScroll(props.el)} className="text-btn">{props.text}</button>
      }
    </div>
  );
};
export default ScrollToElementBtn;